module.exports = __webpack_public_path__ + "static/media/dateIcon-img.29f2c2fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dateIcon-img.svg
// module id = 896
// module chunks = 0